import PageTitle from "@/components/composite/Headers/PageTitle";
import { Package } from "lucide-react";
import { useLocation } from "react-router-dom";
import { ShipmentsTable } from "./ShipmentsTable";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const queryClient = new QueryClient()

export default function ShipmentsLayout() {
    const location = useLocation();

    const queryParams = new URLSearchParams(location.search);
    // Handle both single status parameter and multiple statuses (comma-separated)
    const statusParam = queryParams.get("status") || "";
    const statusValues = statusParam.split(',').filter(status => status.trim() !== "");
    
    // When no status is specified or empty, pass an empty array to show all
    const initialColumnFiltersState = statusValues.length > 0 
        ? [{ id: "status", value: statusValues }]
        : [];

    return (
        <>
            <PageTitle>
                <Package />
                Shipments
            </PageTitle>
            {/* <DataTable columns={columns} data={data} refreshData={fetchData} loading={loading} page={page} pageSize={pageSize} setPage={_setPage} setPageSize={_setPageSize} filterStatuses={filterStatuses}/> */}
            <QueryClientProvider client={queryClient}>
                <ShipmentsTable initialColumnFiltersState={initialColumnFiltersState} pageSize={window.innerWidth < 768 ? 30 : 10} />
            </QueryClientProvider>
        </>
    );
}
